import React from 'react';
import cx from 'classnames';

export const Button = ({ children, className, onClick, tooltip, icon, disabled }) => {
  const buttonClass = cx('btn', className, {
    'btn-icon': icon,
  });

  return (
    <button
      type="button"
      disabled={disabled}
      className={buttonClass}
      data-toggle={tooltip ? 'tooltip' : undefined}
      data-original-title={tooltip || undefined}
      onClick={onClick}
    >
      {icon && (
        <i className={`feather ${icon}`} />
      )}
      {children}
    </button>
  );
};
